import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Ewallet = Loadable(lazy(() => import("src/pages/financial/ewallet")));
const DepositWallet = Loadable(
  lazy(() => import("src/pages/financial/deposit"))
);
const FundCredits = Loadable(
  lazy(() => import("src/pages/financial/fundCredit"))
);
const Payout = Loadable(
  lazy(() => import("src/pages/financial/payout/payout"))
);
const FinancialReport = Loadable(
  lazy(() => import("src/pages/financial/financialReport/financialReport"))
);
const PointHistory = Loadable(
  lazy(() => import("src/pages/financial/point/index"))
);

const PointRevert = Loadable(
  lazy(() => import("src/pages/financial/pointRevertHistory/index"))
);
const financial = [
  {
    path: "financial",
    children: [
      { element: <Navigate to="e-wallet" />, index: true },
      { path: "e-wallet", element: <Ewallet /> },
      // { path: "deposit-wallet", element: <DepositWallet /> },
      { path: "point-history", element: <PointHistory /> },
      { path: "fund-credits", element: <FundCredits /> },
      { path: "payout", element: <Payout /> },
      { path: "report", element: <FinancialReport /> },
      { path: "point_revert", element: <PointRevert /> },
    ],
  },
];

export default financial;
